module.exports = __webpack_public_path__ + "static/media/brainwave-logo2.6cd64eac.jpg";